import { h } from 'preact'
import { memo } from 'preact/compat'
import PropTypes from 'prop-types'
import './style.scss'

const RadioBox = ({ label, inputProps, children, labelProps, name }) => (
  <label className="input input-radio" htmlFor={inputProps.id} {...labelProps}>
    <div className="group">
      <input type="radio" {...inputProps} />
      <span className="svg-radio">
        <svg className="svg" width="24px" height="24px" viewBox="0 0 24 24">
          <circle className="fill" cx="12" cy="12" r="11" />
          <circle className="stroke" cx="12" cy="12" r="11" />
        </svg>
      </span>
      <div className="label-text">{label}</div>
    </div>

    {children && <div className="label-content">{children}</div>}
  </label>
)

RadioBox.propTypes = {
  children: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  inputProps: PropTypes.object.isRequired,
  labelProps: PropTypes.object,
}

export default memo(RadioBox)
